import { ThunkAction } from 'redux-thunk';
import { ValueOf } from 'type-fest';
import requestGetHeroPlannerCountryStates from '~/queries/customerCommunication/requestGetHeroPlannerCountryStates';
import { getRecordKeyFor } from '~/reducers/customerCommunicationReducer';

import { isRequestInitial } from '~/utils/requestUtils';

import CustomerCommunicationAction, { CustomerCommunicationActionTypes } from './customerCommunicationAction';

type CountryStatesParams = NonNullable<
  ValueOf<CustomerCommunication.CustomerCommunicationReduxState['countryGroupCountryStatesRecords']>['params']
>;

const fetchHeroPlannerCountryStates =
  (
    brand: string,
    countryGroupId: string,
    countryId: string,
  ): ThunkAction<void, App.State, unknown, CustomerCommunicationAction> =>
  async (dispatch, getState) => {
    const appState = getState();

    const params = [brand, countryGroupId, countryId] as CountryStatesParams;
    const key = getRecordKeyFor(...params);
    const existing = appState.customerCommunication.countryGroupCountryStatesRecords[key];
    if (!existing || isRequestInitial(existing)) {
      dispatch({
        type: CustomerCommunicationActionTypes.SET_COUNTRY_GROUP_COUNTRY_STATES_FETCHING,
        params,
      });
      try {
        const countryStates = await requestGetHeroPlannerCountryStates(...params);
        dispatch({
          type: CustomerCommunicationActionTypes.SET_COUNTRY_GROUP_COUNTRY_STATES_FULFILLED,
          params,
          countryStates,
        });
      } catch (error) {
        dispatch({
          type: CustomerCommunicationActionTypes.SET_COUNTRY_GROUP_COUNTRY_STATES_REJECTED,
          params,
          error,
        });
      }
    }
  };

export default fetchHeroPlannerCountryStates;
